<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸检测</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对图片的BGR24倒立数据进行人脸检测与分析，该接口与视频人脸检测与跟踪接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct** __stdcall SKFaceImageDetect(unsigned char *pBGR24Data, 
		int nWidth, int nHeight, int nModel,bool bAttributesModel, 
		bool bFeatureModel, bool bKeyPointModel, int &nFaceNum);</code></pre>
    <h3 class="doc_main_h3">参数</h3>
    <p class="doc_main_p">（1）pBGR24Data：图片的bgr数据（BGR倒立数据）</p>
    <p class="doc_main_p">（2）nWidth：图片宽度</p>
    <p class="doc_main_p">（3）nHeight：图片高度</p>
    <p class="doc_main_p">
    	（4）nModel：表示检测模式，0：默认人脸检测，1：快速人脸检测，2：大头照人脸检测（建议使用1快速人脸检测）
    </p>
    <p class="doc_main_p">
    	（5）bAttributesModel：是否需要属性信息（性别[0 不清楚 1 女性 2 男性]、年龄[<=0 表示不清楚]、是否戴眼镜[0 不戴眼镜 1 戴眼镜 2 太阳镜 <0 表示不清楚]）
    </p>
    <p class="doc_main_p">
    	（6）bFeatureModel：是否需要特征值
    </p>
    <p class="doc_main_p">
    	（7）bKeyPointModel：是否需要关键点信息（人脸形状72个关键点信息，先x后y【企业版提供】）
    </p>
    <p class="doc_main_p">
    	（8）nFaceNum: 人脸数量
    </p>
    <h3 class="doc_main_h3">返回值</h3>
	  <test-result-structure></test-result-structure>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nFaceNum = 0;
CFaceStruct **pFacesList = SKFaceImageDetect(pBGRData,1920,1080,1,true,true,true,nFaceNum);
for(int i = 0;i < nFaceNum;i++)
{
    CFaceStruct *pFace = pFacesList[i];
    // 处理人脸信息
}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
  import TestResultStructure from '../../../../components/testResultStructure';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
      'test-result-structure':TestResultStructure,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','图片接口','人脸检测'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/image/faceTesting.vue